var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMobileDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 153,
    rx: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6089_8372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.308 49.0078V57.7978H103.029L112.308 63.1467V74.6672L97.5073 65.9894L82.7065 75.2657V63.7825L91.91 57.7978H82.6689V49.0078H112.308Z",
    fill: "#0073EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.741 82.7465H96.9815V78.5198H85.6367V103.992H128.048V49.0078H116.703V82.7465H116.741ZM116.741 95.2022H96.9815V92.135H116.741V95.2022Z",
    fill: "#0073EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6066 49.0078H53.3303V60.3039H64.2619V78.5198H75.6066V49.0078Z",
    fill: "#0073EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6203 60.3039V49.0078H33.6835H25.344V60.3039V67.8596V78.5198H33.6835H47.6203V67.8596H36.4634V60.3039H47.6203Z",
    fill: "#0073EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6089_8372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.096,
    height: 54.9844,
    fill: "white",
    transform: "translate(24.9521 49.0078)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobileDownload);
export default __webpack_public_path__ + "static/media/logo-mobile-download.9eb103a330167ec5d975b7c36d9dacde.svg";
export { ForwardRef as ReactComponent };